<app-header></app-header>
<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">

        <!-- for content page  --> 
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Statistical Data</a></li>
                <li class="breadcrumb-item"><a href="javascript:void(0);" class="active-nemu">Import of Wheat</a>
                </li>
            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">

            <!-- for content page  -->
            <div class="row">
                <div class="col-lg-2 col-xl-3 col-xxl-2">
                    <div style="height:100%;">
                        <app-statistical-data-sidenav></app-statistical-data-sidenav>
                    </div>
                </div>
                <div class="col-lg-10 col-xl-9 col-xxl-10">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="statistical-content inner-page-sidedetails">
                        <div id="section-New"></div>
                        <div class="details">
                            <div class="title d-flex justify-content-between">
                                <h2>Import of Wheat</h2>
                                <div class="view-data">
                                    <ul>
                                        <li><a (click)="Toggle(true)" id="impwheatchart" class="Toggle"><i class="fa fa-bar-chart"></i></a></li>
                                        <li><a (click)="Toggle(false)" id="impwheattbl" class="Toggle active"><i class="fa fa-table"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="description">
                                <div class="inner-content">
                                    <div class="row">
                                        <div div class="col-lg-12" [hidden]="ShowTabView">
                                            <div class="tabs-data font-adjust d-flex align-items-center ">
                                                <a class="tabs-item" [routerLink]='["/statistical-data/export-data"]'>Export Data</a>
                                                <a class="tabs-item active" [routerLink]='["/statistical-data/import-wheat"]'>Import of Wheat</a>
                                           </div>
                                            <div>
                                                <div class="top-tab d-flex justify-content-between align-items-center">
                                                    <h4 class="mb-0">Import of Wheat {{ selectYear }} <small>(Figure in LMT)</small></h4>
                                                    <div class="d-flex select-data align-items-center">
                                                        <div class="select-items"> 
                                                            <select class="form-select" (change)="searchQCList(YearList)" id="f_Year" name="f_Year" #YearList >
                                                                <option value="">--Select Year--</option>
                                                                <option [value]="item.VchYear" *ngFor="let item of yearlist">{{ item.VchYear }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="table-responsive font-adjust">
                                                    <table class="table table-sm table-hover" aria-labelledby="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" style="width:40px">#{{'SlNo'| translate}}</th>
                                                                <th scope="col">Year(from-to)</th>
                                                <th scope="col">Import From Country</th>
                                                <th scope="col">Wheat</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of getQC_Data | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords }; let i= index">
                                                                <td *ngIf="currentPage==1">{{i+1}}</td>
                                                                <td *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (i+1)}}</td>                               
                                                                <td>{{item.VchYear}}</td>
                                                                <td>{{item.VchImportFromCountry}}</td>
                                                                <td>{{ item.VchWheat}}</td>
                                                              </tr>
                                                           
                                                        </tbody>
                                                    </table>
                                                    
                                                    <div class="my-4">
                                                        <pagination-controls id="pg1" class="text-center pg1"
                                                        (pageChange)="pageChanged($event,YearList)" *ngIf="totalRecords > limit"></pagination-controls>
                                                    </div>
                                                </div> 
                                        </div>
                                        </div>
                                <div class="col-lg-12" [hidden]="!ShowTabView">
                                    <div class="tabs-data font-adjust d-flex align-items-center ">
                                        <a class="tabs-item" [routerLink]='["/statistical-data/export-data"]'>Export Data</a>
                                        <a class="tabs-item active" [routerLink]='["/statistical-data/import-wheat"]'>Import of Wheat</a>
                                   </div>
                                            <div class="content-details">
                                                <div class="top-tab d-flex justify-content-between align-items-center">
                                                    <h4 class="mb-0">Import of Wheat {{ selectYear_ }} <small>(Figure in LMT)</small></h4>
                                                    <div class="d-flex select-data align-items-center">
                                                        <div class="select-items">
                                                            <select class="form-select" (change)="searchQCChatList(YearList1)" id="f_Year1" name="f_Year1" #YearList1 >
                                                                <option value="">--Select Year--</option>
                                                                <option [value]="item.VchYear" *ngFor="let item of yearlist">{{ item.VchYear }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            <div id="chart-importwheat"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>